/**
 * Application version utility.
 *
 * Provides the application version number from package.json as a single source of truth.
 * This ensures version consistency across the entire application.
 *
 * @module version
 */

import packageJson from '../../package.json';

/**
 * Current application version from package.json
 */
export const APP_VERSION = packageJson.version;
